import { Col, Row, Button, Form, FormGroup, FormLabel, FormControl, Spinner } from "react-bootstrap";
import { useEffect, useState, useCallback } from 'react';
import { states } from '../QuoteEstimate/constants.js';
import axios from 'axios'




export function SubscriberInfo({ idToken, username }) {

    const [isDisabled, setIsDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({});
    const [isLoading, setIsLoading] = useState(true);



    const getUserInfo = useCallback(async () => {
        if (username.length > 0) {
            let user = await axios.get(`${process.env.REACT_APP_QMI_BASE_API}/professional/${username}`, { headers: { Authorization: idToken } });
            if (user.status === 204 || user.data === '') {

            }
            else {
                setForm(user.data)
                setIsDisabled(true)
                setIsLoading(false);
            }
        }
    }, [username, idToken]);


    useEffect(() => {
        getUserInfo()
    }, [getUserInfo]);





    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })

        if (!!errors[field])
            setErrors({
                ...errors,
                [field]: null
            })
    };

    const validateForm = () => {
        const { industry, phone, address, city, state, zip, description, website } = form
        const newErrors = {}


        if (!industry || industry === "") newErrors.industry = 'Please enter your Industry.'


        if (!address || address === "") newErrors.address = 'Please enter your Address.'

        if (!phone || phone === "") newErrors.phone = 'Please enter your Phone number.'
        else if (!/^[0-9+]+$/.test(phone)) newErrors.phone = 'Please enter a valid Phone number'
        else if (phone.length < 10) newErrors.phone = 'Phone number is too short'

        if (!zip || zip === "") newErrors.zip = 'Please enter your Zip code.'
        else if (!/^[0-9]+$/.test(zip)) newErrors.zip = 'Please enter a valid Zip code'
        else if (zip.length < 5) newErrors.zip = 'Zip code is too short'

        if (!website || website === "") newErrors.website = 'Please enter a Website.'

        if (!city || city === "") newErrors.city = 'Please enter your City.'

        if (!state) newErrors.state = 'Please select your State.'

        if (!description || description === "") newErrors.description = 'Please enter a Description.'

        return newErrors
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formErrors = validateForm()
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
        }
        else {
            await axios.post(`${process.env.REACT_APP_QMI_BASE_API}/professional/${username}`,
                form,
                {
                    headers: {
                        Authorization: idToken,
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => console.log(res))
                .catch(err => console.log(err));
            setIsDisabled(!isDisabled);
        };
    };


    const handleEdit = (event) => {
        event.preventDefault();
        setIsDisabled(!isDisabled)
    };

    return (
        <>
            {
                isLoading ?
                    (<div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>) :
                    <Form>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <FormLabel> Company Name </FormLabel>
                                    <FormControl
                                        type='text'
                                        placeholder="Enter Company Name"
                                        required
                                        isInvalid={!!errors.companyName}
                                        value={form.companyName || ''}
                                        onChange={e => setField('industry', e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.companyName}
                                    </Form.Control.Feedback>
                                </Col>
                                <Col>
                                    <FormLabel> Industry </FormLabel>
                                    <Form.Select
                                        aria-label="Industry"
                                        required
                                        value={form.industry}
                                        isInvalid={!!errors.industry}
                                        onChange={e => setField('industry', e.target.value)}
                                        disabled={isDisabled}>
                                        <option hidden>Select Industry</option>
                                        <option value="Lawyer" >Lawyer</option>
                                        <option value="Chiropractor" >Chiropractor</option>
                                    </Form.Select>
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.state}
                                    </Form.Control.Feedback>
                                </Col>
                                {/* <Col>
                                    <FormLabel> Industry </FormLabel>
                                    <FormControl
                                        type='text'
                                        placeholder="Enter Industry"
                                        required
                                        isInvalid={!!errors.industry}
                                        value={form.industry || ''}
                                        onChange={e => setField('industry', e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.industry}
                                    </Form.Control.Feedback>
                                </Col> */}
                                <Col>
                                    <FormLabel> Phone </FormLabel>
                                    <FormControl
                                        type='text'
                                        placeholder="Enter Phone"
                                        required
                                        maxLength={12}
                                        isInvalid={!!errors.phone}
                                        value={form.phone || ''}
                                        onChange={e => setField('phone', e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.phone}
                                    </Form.Control.Feedback>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <FormLabel> Address </FormLabel>
                            <FormControl
                                type='text'
                                placeholder="Enter Address"
                                required
                                isInvalid={!!errors.address}
                                value={form.address || ''}
                                onChange={e => setField('address', e.target.value)}
                                disabled={isDisabled}
                            />
                            <Form.Control.Feedback
                                type="invalid"> {errors.address}
                            </Form.Control.Feedback>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col>
                                    <FormLabel> City </FormLabel>
                                    <FormControl
                                        type='text'
                                        placeholder="Enter City"
                                        required
                                        isInvalid={!!errors.city}
                                        value={form.city || ''}
                                        onChange={e => setField('city', e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.city}
                                    </Form.Control.Feedback>
                                </Col>
                                <Col>
                                    <FormLabel> State </FormLabel>
                                    <Form.Select
                                        aria-label="State"
                                        required
                                        value={form.state}
                                        isInvalid={!!errors.state}
                                        onChange={e => setField('state', e.target.value)}
                                        disabled={isDisabled}>
                                        <option hidden>Select State</option>
                                        {states.map((state, index) => {
                                            return (<option value={state.name} key={index}>{state.abbreviation}</option>)
                                        })};
                                    </Form.Select>
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.state}
                                    </Form.Control.Feedback>
                                </Col>
                                <Col>
                                    <FormLabel> Zip </FormLabel>
                                    <FormControl
                                        type='text'
                                        placeholder="Enter Zip"
                                        required
                                        maxLength={5}
                                        isInvalid={!!errors.zip}
                                        value={form.zip || ''}
                                        onChange={e => setField('zip', e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"> {errors.zip}
                                    </Form.Control.Feedback>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <FormLabel> Description </FormLabel>
                            <FormControl
                                placeholder="Enter Description"
                                required
                                isInvalid={!!errors.description}
                                value={form.description || ''}
                                onChange={e => setField('description', e.target.value)}
                                as="textarea"
                                rows={2}
                                disabled={isDisabled}
                            />
                            <Form.Control.Feedback
                                type="invalid"> {errors.description}
                            </Form.Control.Feedback>
                        </FormGroup>

                        <FormGroup>
                            <FormLabel> Website </FormLabel>
                            <FormControl
                                type='text'
                                placeholder="Enter Website"
                                required
                                isInvalid={!!errors.website}
                                value={form.website || ''}
                                onChange={e => setField('website', e.target.value)}
                                disabled={isDisabled}
                            />
                            <Form.Control.Feedback
                                type="invalid"> {errors.website}
                            </Form.Control.Feedback>
                        </FormGroup>


                        {isDisabled ? (<div style={{ display: 'flex', justifyContent: 'center', transform: 'translateY(20px)' }}>
                            <Button
                                onClick={handleEdit}
                                as="input"
                                type="button"
                                value="Edit"
                                variant="outline-primary"
                            />
                        </div>) : (<div style={{ display: 'flex', justifyContent: 'center', transform: 'translateY(20px)' }}>
                            <Button
                                onClick={handleSubmit}
                                as="input"
                                type="submit"
                                value="Submit"
                                variant="outline-primary"
                            />
                        </div>)}

                    </Form>
            }
        </>

    );
}